import React, { useEffect } from 'react';
import PdaPage from '../components/PdaPage';
import { preloadDynamsoftCode128 } from '../services/dynamsoftCode128Diagnostic';
import { getQrmarkScanner } from '../services/qrmarkScanner';
import { navigateTo, reloadTo } from '../utils/navigation';
import { notifyInfo } from '../utils/pdaFeedback';
import { clearSession, getStoredUser } from '../utils/session';

function preloadPmiCameraEngines() {
  void getQrmarkScanner().catch(() => undefined);
  void preloadDynamsoftCode128().catch(() => undefined);
}

function Home() {
  const user = getStoredUser();
  const displayName = user?.full_name || user?.username || '未命名员工';

  useEffect(() => {
    preloadPmiCameraEngines();
  }, []);

  const menuItems = [
    {
      badgeClassName: 'menu-btn__badge menu-btn__badge--blue',
      badgeText: '任',
      desc: '查看待领取物料任务,领取后继续执行',
      key: 'tasks',
      onClick: () => navigateTo('/tasks'),
      title: '我的任务',
    },
    {
      badgeClassName: 'menu-btn__badge menu-btn__badge--green',
      badgeText: '库',
      desc: '查看已领未上架物料和 BID 明细',
      key: 'my-holding',
      onClick: () => navigateTo('/my-holding'),
      title: '我的虚拟库',
    },
    {
      badgeClassName: 'menu-btn__badge menu-btn__badge--orange',
      badgeText: '检',
      desc: '扫 PMI 任务或单件流水号',
      key: 'pmi-scan',
      onClick: () => navigateTo('/pmi-scan'),
      title: 'PMI 扫码',
    },
    {
      badgeClassName: 'menu-btn__badge menu-btn__badge--blue',
      badgeText: '连',
      desc: '自动识别 80×80 / 60×60,连续等待光谱检测',
      key: 'pmi-continuous',
      onClick: () => {
        preloadPmiCameraEngines();
        navigateTo('/pmi-continuous');
      },
      title: '连续 PMI 检测',
    },
    {
      badgeClassName: 'menu-btn__badge menu-btn__badge--orange',
      badgeText: '贴',
      desc: '扫预送货任务,逐张确认正式标签',
      key: 'label-verification',
      onClick: () => reloadTo('/scan/label-verification'),
      title: '贴标核验',
    },
    {
      badgeClassName: 'menu-btn__badge menu-btn__badge--green',
      badgeText: '铲',
      desc: '扫预送货单号,选择铲板并冻结库存',
      key: 'delivery-pallet-bind',
      onClick: () => navigateTo('/scan/delivery-pallet-bind'),
      title: '铲板绑定',
    },
    {
      badgeClassName: 'menu-btn__badge menu-btn__badge--blue',
      badgeText: '原',
      desc: '预入库单 QR → 库位 → 逐支重量长度',
      key: 'pre-inbound',
      onClick: () => navigateTo('/scan/pre-inbound'),
      title: '原材料入库',
    },
    {
      badgeClassName: 'menu-btn__badge menu-btn__badge--blue',
      badgeText: '入',
      desc: '库位码 → 多个料头码 → 每件重量长度',
      key: 'inbound',
      onClick: () => navigateTo('/scan/inbound'),
      title: '料头入库',
    },
    {
      badgeClassName: 'menu-btn__badge menu-btn__badge--green',
      badgeText: '出',
      desc: '料头码 → 用途 + 可选重量',
      key: 'outbound',
      onClick: () => navigateTo('/scan/outbound'),
      title: '出库',
    },
    {
      badgeClassName: 'menu-btn__badge menu-btn__badge--orange',
      badgeText: '调',
      desc: '料头码 → 目标库位',
      key: 'transfer',
      onClick: () => navigateTo('/scan/transfer'),
      title: '调库',
    },
    {
      badgeClassName: 'menu-btn__badge menu-btn__badge--slate',
      badgeText: '查',
      desc: '扫原材料 BID,看本体 / 库位 / 时间线',
      key: 'trace-raw-material',
      onClick: () => navigateTo('/trace/raw-material'),
      title: '原材料追溯',
    },
    {
      badgeClassName: 'menu-btn__badge menu-btn__badge--slate',
      badgeText: '查',
      desc: '扫料头码,看当前位置和时间线',
      key: 'trace',
      onClick: () => navigateTo('/trace'),
      title: '料头追溯',
    },
  ];

  function handleLogout() {
    if (!window.confirm('确认退出登录？')) {
      return;
    }

    clearSession();
    notifyInfo('已退出登录');
    navigateTo('/login', true);
  }

  return (
    <PdaPage
      actionLabel="退出登录"
      onAction={handleLogout}
      subtitle={`${displayName}${user?.emp_no ? ` · ${user.emp_no}` : ''}`}
      title="料头扫码"
    >
      <section className="panel">
        <div className="panel-title">今天要做的事</div>
        <div className="panel-hint">
          所有动料必须扫码。当前登录态会自动记录操作人，过期后再回登录页重新扫卡。
        </div>
      </section>

      <section className="menu-grid">
        {menuItems.map((item) => (
          <button className="menu-btn" key={item.key} onClick={item.onClick} type="button">
            <div className="menu-btn__head">
              <div className={item.badgeClassName}>{item.badgeText}</div>
              <div className="menu-btn__title">{item.title}</div>
            </div>
            <div className="menu-btn__desc">{item.desc}</div>
          </button>
        ))}
      </section>
    </PdaPage>
  );
}

export default Home;
